module.exports = __webpack_public_path__ + "static/media/greenBurger.9a010407.svg";